import React from "react";
import { useLabels } from "../../../hooks/useLabels";
import { BottomMenuPanel } from "../../bottom-menu-panel";
import { BottomMenuButtons, BottomMenuSeparator } from "../../bottom-menu/buttons";
import { labels } from "./labels";
import "./text-alignment-panel.css";
import { BottomMenuButton } from "../../bottom-menu/bottom-menu-button";

export const TextAlignmentPanel = ({
	selectedHorizontalAlignment,
	setHorizontalAlignment,
	selectedVerticalAlignment,
	setVerticalAlignment,
	canSetHorizontalAlignmentToNear,
	canSetHorizontalAlignmentToCenter,
	canSetHorizontalAlignmentToFar,
	canSetVerticalAlignmentToNear,
	canSetVerticalAlignmentToCenter,
	canSetVerticalAlignmentToFar,
}: {
	selectedHorizontalAlignment: eXpress.core.TextAlignment;
	setHorizontalAlignment(alignment: eXpress.core.TextAlignment): void;
	selectedVerticalAlignment: eXpress.core.TextAlignment;
	setVerticalAlignment(alignment: eXpress.core.TextAlignment): void;
	canSetHorizontalAlignmentToNear: boolean;
	canSetHorizontalAlignmentToCenter: boolean;
	canSetHorizontalAlignmentToFar: boolean;
	canSetVerticalAlignmentToNear: boolean;
	canSetVerticalAlignmentToCenter: boolean;
	canSetVerticalAlignmentToFar: boolean;
}) => {
	const [[labelBottom, labelCenter, labelLeft, labelMiddle, labelRight, labelTop]] = useLabels([
		labels.bottom,
		labels.center,
		labels.left,
		labels.middle,
		labels.right,
		labels.top,
	]);

	return (
		<BottomMenuPanel>
			<BottomMenuButtons scrollableClassName="text-alignment-panel">
				<BottomMenuButton
					title={labelLeft}
					isActive={selectedHorizontalAlignment === eXpress.core.TextAlignment.Near}
					iconName="text-align-left"
					onClick={() => setHorizontalAlignment(eXpress.core.TextAlignment.Near)}
					isDisabled={!canSetHorizontalAlignmentToNear}
					id="text-align-left"
				/>
				<BottomMenuButton
					title={labelCenter}
					isActive={selectedHorizontalAlignment === eXpress.core.TextAlignment.Center}
					iconName="text-align-center"
					onClick={() => setHorizontalAlignment(eXpress.core.TextAlignment.Center)}
					isDisabled={!canSetHorizontalAlignmentToCenter}
					id="text-align-center"
				/>
				<BottomMenuButton
					title={labelRight}
					isActive={selectedHorizontalAlignment === eXpress.core.TextAlignment.Far}
					iconName="text-align-right"
					onClick={() => setHorizontalAlignment(eXpress.core.TextAlignment.Far)}
					isDisabled={!canSetHorizontalAlignmentToFar}
					id="text-align-right"
				/>
				<BottomMenuSeparator key="separator" />
				<BottomMenuButton
					title={labelTop}
					isActive={selectedVerticalAlignment === eXpress.core.TextAlignment.Near}
					iconName="text-valign-top"
					onClick={() => setVerticalAlignment(eXpress.core.TextAlignment.Near)}
					isDisabled={!canSetVerticalAlignmentToNear}
					id="text-valign-top"
				/>
				<BottomMenuButton
					title={labelMiddle}
					isActive={selectedVerticalAlignment === eXpress.core.TextAlignment.Center}
					iconName="text-valign-middle"
					onClick={() => setVerticalAlignment(eXpress.core.TextAlignment.Center)}
					isDisabled={!canSetVerticalAlignmentToCenter}
					id="text-valign-middle"
				/>
				<BottomMenuButton
					title={labelBottom}
					isActive={selectedVerticalAlignment === eXpress.core.TextAlignment.Far}
					iconName="text-valign-bottom"
					onClick={() => setVerticalAlignment(eXpress.core.TextAlignment.Far)}
					isDisabled={!canSetVerticalAlignmentToFar}
					id="text-valign-bottom"
				/>
			</BottomMenuButtons>
		</BottomMenuPanel>
	);
};
TextAlignmentPanel.displayName = "TextAlignmentPanel";
